import { Icon, TextField } from "@platform/design-system";

interface CarrierSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const CarrierSearchField = ({
  value,
  onChange,
}: CarrierSearchFieldProps): React.JSX.Element => (
  <TextField
    data-testid="carrier-search-field"
    fullWidth
    placeholder="Search carrier, rep email or name"
    startAdornment={<Icon name="search" size="sm" color="muted" />}
    value={value}
    onChange={(event) => onChange(event.target.value)}
  />
);
